import React from 'react';
import { Route, Routes } from '@common/components';
import { PublicRoute } from '@routes/public-route';
import {
  ActivateAccountPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  SignInFailurePage,
  SignInPage,
  SignInSuccessPage,
  SupplierSignUpPage,
} from '@identity/pages';

export function PublicRoutes() {
  return (
    <Routes>
      <Route
        path="/works/sign_in"
        element={<PublicRoute page={SignInPage} />}
      />
      <Route
        path="/works/auth/success/:ssoToken/:email/:entityType/:membershipRole/:membershipId/:ssoOrigin"
        element={<PublicRoute page={SignInSuccessPage} />}
      />
      <Route
        path="/works/auth/failure/:error"
        element={<PublicRoute page={SignInFailurePage} />}
      />
      <Route
        path="/works/auth/forgot-password"
        element={<PublicRoute page={ForgotPasswordPage} />}
      />
      <Route
        path="/works/auth/reset-password/:token"
        element={<PublicRoute page={ResetPasswordPage} />}
      />
      <Route
        path="/works/auth/activate-account/:token"
        element={<PublicRoute page={ActivateAccountPage} />}
      />
      <Route
        path="/works/supplier/signup/:token"
        element={<PublicRoute page={SupplierSignUpPage} />}
      />

      <Route path="*" element={null} />
    </Routes>
  );
}
